import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import {
	init, identify, Identify, setUserId, reset,
} from '@amplitude/analytics-browser';
import { GreenroomState } from '../stores/types/types';
import { AmpUserProp } from '../types/amplitude';

const useAmplitude = () => {
	const [identifiedUser, setHasIdentifiedUser] = useState(0);

	const user = useSelector((state: GreenroomState) => state.SessionReducer.user);
	const room = useSelector((state: GreenroomState) => state.SessionReducer.meeting);
	const host = useSelector(
		(state: GreenroomState) => state.SessionReducer.host,
	);

	useEffect(() => {
		if (process.env.REACT_APP_AMPLITUDE_API_KEY) {
			init(process.env.REACT_APP_AMPLITUDE_API_KEY);
		}
	}, []);

	useEffect(() => {
		if (!user?.gr_user) {
			// when they log out, reset analytics data
			reset();
			setHasIdentifiedUser(0);
		} else if (user.gr_user !== identifiedUser) {
			// when they log in, identified user should be 0
			setUserId(`gr_user_${user.gr_user}`);

			const newProps = new Identify();
			newProps.set(AmpUserProp.email, user?.email ?? '');
			identify(newProps);

			setHasIdentifiedUser(user?.gr_user);
		}
	}, [user?.gr_user]);

	useEffect(() => {
		const newProps = new Identify();
		newProps.set(AmpUserProp.userRole, host ? 'producer' : 'presenter');
		identify(newProps);
	}, [host]);

	useEffect(() => {
		const newProps = new Identify();
		if (room?.meeting) {
			newProps.set(AmpUserProp.roomId, room.meeting);
			newProps.set(AmpUserProp.roomSlug, room.meeting_id);
			newProps.set(AmpUserProp.channelId, room.channel);
			newProps.set(AmpUserProp.eventsUUID, room.events_session_uuid ?? '');
			newProps.set(AmpUserProp.roomTitle, room.title);
		} else {
			newProps.set(AmpUserProp.roomId, 0);
			newProps.set(AmpUserProp.roomSlug, '');
			newProps.set(AmpUserProp.channelId, 0);
			newProps.set(AmpUserProp.eventsUUID, '');
			newProps.set(AmpUserProp.roomTitle, '');
		}
		identify(newProps);
	}, [room?.meeting]);
};

export default useAmplitude;
